// extracted by mini-css-extract-plugin
export default {"cards":"StartPage_cards__0KAev"};